// Show types
export const COMPANY_SHOW_ERROR = 'COMPANY_SHOW_ERROR';
export const COMPANY_SHOW_LOADING = 'COMPANY_SHOW_LOADING';
export const COMPANY_SHOW_RETRIEVED_SUCCESS = 'COMPANY_SHOW_RETRIEVED_SUCCESS';
export const COMPANY_SHOW_RESET = 'COMPANY_SHOW_RESET';

// Update types
export const COMPANY_UPDATE_RESET = 'COMPANY_UPDATE_RESET';
export const COMPANY_UPDATE_UPDATE_ERROR = 'COMPANY_UPDATE_UPDATE_ERROR';
export const COMPANY_UPDATE_UPDATE_LOADING = 'COMPANY_UPDATE_UPDATE_LOADING';
export const COMPANY_UPDATE_UPDATE_SUCCESS = 'COMPANY_UPDATE_UPDATE_SUCCESS';
export const COMPANY_UPDATE_RETRIEVE_ERROR = 'COMPANY_UPDATE_RETRIEVE_ERROR';
export const COMPANY_UPDATE_RETRIEVE_LOADING = 'COMPANY_UPDATE_RETRIEVE_LOADING';
export const COMPANY_UPDATE_RETRIEVE_SUCCESS = 'COMPANY_UPDATE_RETRIEVE_SUCCESS';
export const COMPANY_UPDATE_UPDATE_VIOLATIONS = 'COMPANY_UPDATE_UPDATE_VIOLATIONS';


// WEBPACK FOOTER //
// ./src/store/modules/company/mutation-types.js